module.exports = __webpack_public_path__ + "img/7.2f0fbbb4.jpg";